import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import {
  RemoveAllowedDomainMutation,
  RemoveAllowedDomainMutationVariables,
} from '../queries/types/RemoveAllowedDomainMutation';
import { Remove_ALLOWED_DOMAIN_MUTATION } from '../queries/saveAllowedDomainsMutation';

type IOptions = MutationHookOptions<RemoveAllowedDomainMutation, RemoveAllowedDomainMutationVariables>;

export const useRemoveAllowedDomain = (options: IOptions = {}) =>
  useMutation<RemoveAllowedDomainMutation, RemoveAllowedDomainMutationVariables>(
    Remove_ALLOWED_DOMAIN_MUTATION,
    options,
  );
